import { render, staticRenderFns } from "./SalesModal.vue?vue&type=template&id=6a595734&"
import script from "./SalesModal.vue?vue&type=script&lang=js&"
export * from "./SalesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports